import React, { CSSProperties, FC, ReactNode } from "react";
import { ButtonContainer, IconWrapper, Text } from "./button.styles";

type Variant = "contain" | "outline" | "text"; // Add more if you support more variants
type Color = string; // Adjust if you use specific color types

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick?: () => void;
  leftIcon?: React.ElementType;
  rightIcon?: React.ElementType;
  color?: Color;
  children?: ReactNode;
  variant?: Variant;
  style?: CSSProperties;
  textStyle?: string;
  disabled?: boolean;
}

const Button: FC<ButtonProps> = ({
  onClick,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  color,
  children,
  variant = "contain",
  style,
  textStyle = "",
  disabled,
  ...rest
}) => (
  <ButtonContainer
    onClick={onClick}
    color={color}
    variant={variant}
    style={style}
    disabled={disabled}
    {...rest}
  >
    {LeftIcon && <IconWrapper as={LeftIcon} />}
    <Text textStyle={textStyle} color={color} variant={variant}>
      {children}
    </Text>
    {RightIcon && <IconWrapper as={RightIcon} />}
  </ButtonContainer>
);

export default Button;
